import React from "react";
import { Checkbox, FormControlLabel, Popover } from "@mui/material";
import * as Styles from "../styles";
import {
  ColumnConfig,
  isCorretor,
  isGerenteVendas,
  canViewEquipeColumn,
  isNonCorretor,
} from "../constants";

interface Props {
  anchorEl: HTMLElement | null;
  isOpen: boolean;
  onClose: () => void;
  tempColumns: ColumnConfig[];
  codigoCargo: string | null;
  usuarioGerenteOnline?: boolean;
  onToggle: (columnId: string) => void;
  onReset: () => void;
  onSave: () => void;
}

const shouldShowColumn = (
  column: ColumnConfig,
  codigoCargo: string | null,
  usuarioGerenteOnline = false
): boolean => {
  switch (column.id) {
    case "ultimaTarefa":
    case "etiqueta":
    case "email":
      return isCorretor(codigoCargo);
    case "corretorResponsavel":
      return isNonCorretor(codigoCargo);
    case "ultimoResponsavel":
      return isGerenteVendas(codigoCargo);
    case "equipe":
      return canViewEquipeColumn(codigoCargo, usuarioGerenteOnline);
    default:
      return true;
  }
};

export const ColumnSelector: React.FC<Props> = ({
  anchorEl,
  isOpen,
  onClose,
  tempColumns,
  codigoCargo,
  usuarioGerenteOnline = false,
  onToggle,
  onReset,
  onSave,
}) => (
  <Popover
    open={isOpen}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    transformOrigin={{ vertical: "top", horizontal: "left" }}
  >
    <Styles.PopoverContainer>
      <Styles.ScrollableContent>
        {tempColumns
          .filter(
            (col) =>
              shouldShowColumn(col, codigoCargo, usuarioGerenteOnline) &&
              !col.alwaysVisible
          )
          .map((column) => (
            <FormControlLabel
              key={column.id}
              control={
                <Checkbox
                  checked={column.visible}
                  onChange={() => onToggle(column.id)}
                  style={{ padding: "4px", color: "#1976D2" }}
                />
              }
              label={
                <div style={{ fontSize: 14, textOverflow: "ellipsis" }}>
                  {column.label || "Sem título"}
                </div>
              }
              style={{
                marginBottom: "4px",
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            />
          ))}
      </Styles.ScrollableContent>
      <Styles.ButtonContainer>
        <Styles.ActionButton onClick={onReset}>Resetar</Styles.ActionButton>
        <Styles.ActionButton primary onClick={onSave}>
          Salvar
        </Styles.ActionButton>
      </Styles.ButtonContainer>
    </Styles.PopoverContainer>
  </Popover>
);
